import { Box, Card, Grid, makeStyles, Radio } from '@material-ui/core';
import { DefaultButton } from 'design-system';
// Data Layer
import { QuotationUnit } from 'data-layer-cr/dist/models';
// Functions
import { isPremiumOption } from 'src/functions/individualOptionHelpers';
// components
import IndividualPriceDetail from 'src/components/screens/components/IndividualPriceDetail';

const useStyles = makeStyles(() => ({
  cardRoot: {
    position: 'relative',
    minWidth: 275,
    borderRadius: 10,
    boxShadow: '0px 2px 15px rgba(0, 0, 0, 0.08)',
    overflow: 'hidden',
  },
  triangle: {
    position: 'absolute',
    borderTop: '48.45px solid #E37E07',
    borderRight: '55.45px solid transparent',
  },
  star: {
    position: 'absolute',
    top: '5px',
    left: '4px',
  },
  container: {
    display: 'flex',
    alignItems: 'flex-start',
    paddingTop: 20,
    paddingBottom: 15,
    paddingLeft: 41,
    paddingRight: 41,
  },
  informationText: {
    fontSize: 15,
    fontWeight: 400,
    lineHeight: 24,
  },
  radio: {
    padding: 0,
    marginTop: 2,
  },
}));

type OptionPriceCardProps = {
  unit: QuotationUnit;
  anualPrice: number;
  moneyType: string | undefined;
  packageOption: number;
  selected: boolean;
  isMobile: boolean;
  onSelected: (packageId: number, forceNext: boolean) => void;
  onDetailsDialogueRequested: (unit: QuotationUnit) => void;
  createdAt?: string;
};

const OptionPriceCard = ({
  anualPrice,
  moneyType,
  packageOption,
  unit,
  selected,
  isMobile,
  onSelected,
  onDetailsDialogueRequested,
  createdAt,
}: OptionPriceCardProps): JSX.Element => {
  const premiumOption = isPremiumOption(packageOption);
  const classes = useStyles();

  return (
    <Card
      className={classes.cardRoot}
      elevation={0}
      data-testid="option-price-card"
    >
      {premiumOption && (
        <>
          <Box className={classes.triangle} />
          <img
            data-testid="premium-star-icon"
            src="svg/premium_start.svg"
            alt="premium star"
            className={classes.star}
          />
        </>
      )}
      <Grid item className={classes.container}>
        <Grid container item spacing={1} direction="column">
          {isMobile && (
            <Grid item container justifyContent="flex-end">
              <Radio
                id="swi-radioselection"
                data-testid="radio"
                checked={selected}
                onChange={(): void => onSelected(unit.package.id, false)}
                className={classes.radio}
              />
            </Grid>
          )}
          <IndividualPriceDetail
            data-testid="individual-price-detail"
            anualPrice={anualPrice}
            moneyType={moneyType}
            packageOption={packageOption}
            createdAt={createdAt}
          />
          <Grid item container justifyContent="center">
            {isMobile ? (
              <DefaultButton
                id={`sales-web-inspection-view-details-${unit.package.id}`}
                data-testid="view-details-button"
                fullWidth
                variant="borderless"
                onClick={(): void => onDetailsDialogueRequested(unit)}
              >
                Ver Detalle
              </DefaultButton>
            ) : (
              <DefaultButton
                id={`sales-web-inspection-button-buy-${unit.package.id}`}
                data-testid="buy-button"
                fullWidth
                onClick={(): void => onSelected(unit.package.id, true)}
              >
                Comprar
              </DefaultButton>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
};

export default OptionPriceCard;
